import { render } from "./Navigation.vue?vue&type=template&id=3412c518"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=3412c518&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__